import React from 'react';
import { Button } from 'react-bootstrap';
import '../assets/css/styles.css'
import '../assets/css/thankyou.css';
import cgLogo from '../assets/images/Capgemini_Logo_Color_RGB.svg';
import blueShape from '../assets/images/blue-shape.png';
import infographic from '../assets/images/infographic.png';
import { Doughnut } from 'react-chartjs-2';
import Footer from '../components/Footer';

class Thankyou extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            data: {
                datasets: [
                    {
                        // label: '# of Votes',
                        data: [this.props.total - this.props.score, this.props.score],
                        backgroundColor: [
                            'rgba(255, 255, 255, 1)',
                            'rgba(18, 171, 219, 0.8)',
                        ],
                        borderColor: [
                            'rgba(255, 255, 255, 1)',
                            'rgba(255, 255, 255, 1)',
                        ],
                        borderWidth: 1,
                        weight: 1,
                        cutout: "70%"
                    },
                ],
            }
        }
        this.download = this.download.bind(this);
        this.imageLoaded = this.imageLoaded.bind(this);

    }

    handleReload = (e) => {
        window.scrollTo(0, 0);
        window.location.reload(false);
    }

    download = () => {
        window.open("/infographic.pdf", "_blank");
    };

    imageLoaded = () => {
        this.setState({
            imageLoading: false
        })
    }

    componentDidMount() {
        // console.log(this.props.currentState);
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <>
                <div className="thankyou-banner d-flex">
                    <div className="cg-logo">
                        <img src={cgLogo} alt="Capgemini Logo" width="150" />
                    </div>
                    <img className="blue-shape" src={blueShape} alt="Thank you banner" />
                    <div className="white-text-box d-flex">
                        <div className="header-white-title-bg">
                            <h4 className="thankyou-h4">WELL DONE!</h4>
                        </div>
                        <p>You’ve completed our digital carbon footprint quiz</p>
                    </div>
                </div>
                <div className="wrap-box">
                    <h4 className="page-h4">Your score</h4>
                    <div className="score-card">
                        <div className="score-text">  <span>{this.props.score}</span><br></br> out of {this.props.total}</div>
                        <Doughnut
                            data={this.state.data}
                        />
                    </div>
                </div>
                <div className="info-spaceholder" style={{visibility: this.state.imageLoading ? "hidden" : "visible"}}>
                    <img src={infographic} width="100%" alt="Download our carbon footprint" onLoad={this.imageLoaded} />
                </div>
                <div className="d-flex main-button-row">
                    <Button className="blue-btn btn btn-primary mt-0" onClick={() => this.download()}>
                        Download our digital carbon footprint facts
                    </Button>
                </div>

                <div className="wrap-box">
                    <h4 className="page-h4 mt-0 pt-0">For more information, here are some useful resources</h4>
                    <ul className="no-box">
                        <li><a href="https://www.capgemini.com/gb-en/our-company/our-corporate-social-responsibility-program/environmental-sustainability/" >Environmental Sustainability</a></li>
                        <li><a href="https://www.capgemini.com/gb-en/events/capgemini-at-cop26-for-an-inclusive-and-sustainable-future/">Capgemini at COP26: for an inclusive and sustainable future</a></li>

                        <li><a href="https://www.itu.int/en/ITU" target="_blank">The Global E-waste: Quantities, flows, and the circular economy potential</a></li>
                        <li><a href="https://www.ifixit.com/Right-to-Repair/Resources" target="_blank">The lifecycle of electronics</a></li>
                        <li><a href="https://earth911.com/eco-tech/recycle-old-phone/" target="_blank">Why and How To Recycle Your Old Mobile Phone</a></li>
                        <li><a href="https://therestartproject.org/" target="_blank">Repair your electronics with The Restart Project</a></li>
                        <li><a href="https://www.gonimble.com/pages/recycling-program" target="_blank">How to recycle Ewaste and related accessories</a></li>

                        <li><a href="https://www.aliternetworks.com/" target="_blank">Reusing IT Networks</a></li>

                        <li><a href="https://www.nationalgrid.com/stories/energy-explained/what-is-net-zero" target="_blank">What is Net Zero?</a></li>

                        <li><a href="https://support.microsoft.com/en-us/office/reduce-the-size-of-your-mailbox-and-outlook-data-files-pst-and-ost-e4c6a4f1-d39c-47dc-a4fa-abe96dc8c7ef" target="_blank">
                            Daily internet recommendation: How to reduce the size of your mailbox and Outlook Data Files</a></li>

                        <li><a href="https://support.microsoft.com/en-us/office/reduce-the-size-of-pictures-and-attachments-in-outlook-email-messages-d0b6b6bf-3b08-4dad-a01c-533719d1c005" target="_blank">Daily internet recommendation: How to reduce the size of pictures and attachments in Outlook email messages</a></li>

                        <li><a href="https://www.bbc.com/future/article/20201217-renewable-power-the-worlds-largest-battery" target="_blank">Device lifecycle recommendation: charging batteries with renewable energy </a></li>

                        <li><a href="https://www.uswitch.com/energy-saving/guides/tvs-computers-laptops/" target="_blank">Energy-saving tips for your TV, computer and laptop</a></li>
                        <li><a href="https://www.capgemini.com/wp-content/uploads/2021/05/Sustainable-IT_Report.pdf" target="_blank">Capgemini Thought leadership – Sustainable IT</a></li>
                        <li><a href="https://www.capgemini.com/gb-en/wp-content/uploads/sites/3/2020/07/Final-Web-Report-Sustainability-In-CPRD-1.pdf" target="_blank">Capgemini Thought leadership – Consumer Preferences</a></li>
                        <li><a href="https://www.linkedin.com/pulse/could-clicks-become-more-dangerous-planet-than-cars-part-menzel/" target="_blank">Capgemini Thought leadership – Sustainable IT</a></li>

                    </ul>
                </div>

                <div className="d-flex main-button-row">
                    <Button className="main-btn"
                        variant="primary"
                        onClick={(e) => { this.handleReload(e) }}>
                        Retry the quiz
                    </Button>
                </div>
                <Footer />
            </>
        )
    }
}

export default Thankyou;